export { default } from './RightSidebarMyPage';



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Main/UpdateAccount/RightSidebarUpdAccount/index.js